<template>
  <preview-sp class="pega-sp-print-area">
    <company-preview-detail-sp
      :is-light-plan="isLightPlan"
      :company-info="companyInfo"
      :report="report"
      :environment="environment"
    />

    <p class="margin-1">
      <small>
        これ以降は、女の転職typeのユーザー画面では表示されません。ただし、提携サイトには表示される場合がございます。あらかじめご了承ください。
      </small>
    </p>

    <company-supplement-preview
      class="margin-1 pega-table-sp"
      :company-supplement-info="companySupplementInfo"
    />
  </preview-sp>
</template>

<script>
import CompanyPreviewDetailSp from '@/components/organisms/CompanyPreviewDetailSp'
import CompanySupplementPreview from '@/components/organisms/CompanySupplementPreview'
import PreviewSp from '@/components/templates/PreviewSp'
import companyPreviewCommon from '@/lib/companyPreviewCommon'

export default {
  components: {
    PreviewSp,
    CompanySupplementPreview,
    CompanyPreviewDetailSp
  },
  // PC・SP共通処理読み込み
  mixins: [companyPreviewCommon]
}
</script>
